import React from 'react';
import { Typography, TypographyProps } from '@cp/ds/src/components/typography';
import { useDeclination } from '@cp/shared/declination';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { DeclinationMnemonic } from '@common/model/resource/declinationMnemonic';

export interface StatsLabelProps extends TypographyProps {
  catalogType: CatalogItemType;
  count: number;
}
export const StatsLabel: React.FC<StatsLabelProps> = ({ catalogType, count }) => {
  const declination = useDeclination();

  return (
    <Typography sx={{ color: 'gray' }} variant="caption">
      {count} {declination(count, catalogType === CatalogItemType.Resume ? DeclinationMnemonic.Specialist : DeclinationMnemonic.Vacancy)}
    </Typography>
  );
};
